import { createRootRoute, Navigate, Outlet, redirect, useNavigate, useRouterState } from '@tanstack/react-router'
import { setTimeout } from 'helpers/setTimeout'
import { SEC_INTERVAL_CHECK_TOKEN, TECH_WORKS } from 'src/constants/global'
import { useTypedSelector } from 'src/hooks'
import { orderRoute } from 'src/modules/order/routes'
import { cleanAuthData, loadValidToken } from 'src/store/auth/auth'
import { store } from 'src/store/store'

// флаг на одну инициализацию тк beforeLoad срабатывает при каждом роуте
let initOnce = true
let TIMEOUT_TOKEN_ID: number | null = null

async function handlePageVisibilityChange() {
  if (document.hidden) {
    return
  }
  initOnce = false

  try {
    await loadValidToken()
  } catch (e) {
    cleanAuthData()
  }
  if (TIMEOUT_TOKEN_ID) {
    clearTimeout(TIMEOUT_TOKEN_ID)
  }
  TIMEOUT_TOKEN_ID = setTimeout(handlePageVisibilityChange, SEC_INTERVAL_CHECK_TOKEN)
}

export const rootRoute = createRootRoute({
  beforeLoad: async (options) => {
    const { token } = store.getState().authReducer

    if (initOnce) {
      handlePageVisibilityChange()
    }

    document.removeEventListener('visibilitychange', handlePageVisibilityChange)
    document.addEventListener('visibilitychange', handlePageVisibilityChange)

    if (TECH_WORKS && options.location.pathname !== '/tech-works') {
      throw redirect({
        to: '/tech-works'
      })
    }

    if (options.location.pathname === '/') {
      if (token) {
        throw redirect({
          to: '/order',
          search: {
            page: 1,
            perPage: 10
          }
        })
      } else {
        throw redirect({
          to: '/auth'
        })
      }
    }
  },
  component: function RouteWrapper() {
    const { token } = useTypedSelector((state) => state.authReducer)
    const {
      location: { pathname }
    } = useRouterState()
    const navigate = useNavigate()

    if (pathname === '/' && token) {
      navigate(orderRoute)
    }

    return <Outlet />
  },
  notFoundComponent: () => <Navigate to="/not-found" />
})
